import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { directLinkStateSelector, loadDirectLink, setStatus, setupDirectLink } from '@src/features/directLink';

import SpinnerBar from '@src/components/reusable/spinner/SpinnerBar';

import { Wrapper, LoadingWrapper, GlobalResetStyles } from './styles';
import Error from '@src/components/DirectLink2/Error';
import { useAppDispatch, useAppSelector, useTranslate, useWidgetParam } from '@src/core/hooks';
import { setupAuth, setupAuthOngoingSelector } from '@src/features/auth';
import Checkout from './Checkout';
import Payment from './Payment';
import FontsProvider from '@src/fonts/FontsProvider';
import FontFamily from './FontFamily';
import { currentSaleSelector } from '@src/features/sale';

const DirectLink = () => {
  const { i18n } = useTranslate();
  const dispatch = useAppDispatch();

  const { directLink, status, error } = useSelector(directLinkStateSelector);
  const setupAuthOngoing = useAppSelector(setupAuthOngoingSelector);

  const planneLinkCode = useWidgetParam('planne-link-code');

  const customerAccessToken = useWidgetParam('customer-access-token');
  const onFinishCheckout = useWidgetParam('on-finish-checkout');
  const useDefaultFont = useWidgetParam('use-default-font');
  const currentSale = useAppSelector(currentSaleSelector);

  const [initiated, setInitiated] = useState(false);

  const isLoading = !initiated || status === 'loading' || setupAuthOngoing;

  const isExpired = directLink?.isExpired;

  const onSuccess = () => {
    const wdw: any = window;

    if (status !== 'finished') {
      if (onFinishCheckout) {
        wdw[onFinishCheckout](currentSale);
      }

      dispatch(setStatus('finished'));
    }
  };

  useEffect(() => {
    if (initiated) {
      if (customerAccessToken) {
        dispatch(setupAuth(false, customerAccessToken));
      }

      if (planneLinkCode) {
        dispatch(loadDirectLink(planneLinkCode));
      }
    }
  }, [planneLinkCode, initiated]);

  useEffect(() => {
    if (!initiated) {
      dispatch(setupDirectLink());

      setInitiated(true);
    }
  }, []);

  return (
    <>
      <FontsProvider />
      <GlobalResetStyles />

      {useDefaultFont === 'true' ? <FontFamily /> : null}

      <Wrapper>
        {isLoading ? (
          <LoadingWrapper>
            <SpinnerBar />
          </LoadingWrapper>
        ) : error ? (
          <Error>{error}</Error>
        ) : isExpired ? (
          <Error>{i18n('direct_link_expired_message')}</Error>
        ) : directLink?.type === 'cart' ? (
          <Checkout onSuccess={onSuccess} />
        ) : directLink?.type === 'sale' ? (
          <Checkout onSuccess={onSuccess} />
        ) : directLink?.type === 'payment' ? (
          <Payment onSuccess={onSuccess} />
        ) : (
          <Error>{i18n('direct_link_invalid_message')}</Error>
        )}
      </Wrapper>
    </>
  );
};

export default DirectLink;
